var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6, _symbol7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSprite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    style: {
      position: "absolute",
      width: 0,
      height: 0,
      overflow: "hidden"
    },
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-shop-cart",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 5.333v1.333h-10.667v-1.333h10.667zM12 29.333c0 1.467-1.2 2.667-2.667 2.667s-2.667-1.2-2.667-2.667c0-1.467 1.2-2.667 2.667-2.667s2.667 1.2 2.667 2.667zM10.667 29.333c0-0.733-0.6-1.333-1.333-1.333s-1.333 0.6-1.333 1.333c0 0.733 0.6 1.333 1.333 1.333s1.333-0.6 1.333-1.333zM25.333 29.333c0 1.467-1.2 2.667-2.667 2.667s-2.667-1.2-2.667-2.667c0-1.467 1.2-2.667 2.667-2.667s2.667 1.2 2.667 2.667zM24 29.333c0-0.733-0.6-1.333-1.333-1.333s-1.333 0.6-1.333 1.333c0 0.733 0.6 1.333 1.333 1.333s1.333-0.6 1.333-1.333zM27.92 18.667h-20.080l-1.667-12h11.16v-1.333h-11.347l-0.347-2.453c-0.227-1.64-1.64-2.88-3.293-2.88h-2.347v1.333h2.347c1 0 1.84 0.747 1.987 1.72l2.693 19.4c0.227 1.64 1.64 2.88 3.307 2.88h16.347v-1.333h-16.36c-1 0-1.84-0.747-1.987-1.72l-0.32-2.28h20.987l1.867-9.333h-1.36l-1.6 8h0.013z"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-search",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.767 25.754c2.772 0 5.329-0.897 7.421-2.391l7.869 7.869c0.365 0.365 0.847 0.548 1.361 0.548 1.079 0 1.843-0.83 1.843-1.893 0-0.498-0.166-0.979-0.531-1.328l-7.819-7.836c1.644-2.158 2.623-4.831 2.623-7.736 0-7.022-5.744-12.767-12.767-12.767-7.006 0-12.767 5.728-12.767 12.767 0 7.023 5.744 12.767 12.767 12.767zM12.767 22.998c-5.479 0-10.011-4.532-10.011-10.011s4.532-10.011 10.011-10.011c5.479 0 10.011 4.532 10.011 10.011s-4.532 10.011-10.011 10.011z"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-Component",
    viewBox: "0 0 76 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2.54-9.651h81.27v46.73h-81.27v-46.73z"
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-cancel",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 2.667c-7.373 0-13.333 5.96-13.333 13.333s5.96 13.333 13.333 13.333c7.373 0 13.333-5.96 13.333-13.333s-5.96-13.333-13.333-13.333zM16 26.667c-5.88 0-10.667-4.787-10.667-10.667s4.787-10.667 10.667-10.667c5.88 0 10.667 4.787 10.667 10.667s-4.787 10.667-10.667 10.667zM16 14.12l4.787-4.787 1.88 1.88-4.787 4.787 4.787 4.787-1.88 1.88-4.787-4.787-4.787 4.787-1.88-1.88 4.787-4.787-4.787-4.787 1.88-1.88 4.787 4.787z"
  }))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-x-close",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M24 8l-16 16"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M8 8l16 16"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-info",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#63a6f7",
    style: {
      fill: "var(--color1, #63a6f7)"
    },
    d: "M14.669 9.335h2.667v2.667h-2.667v-2.667zM14.669 14.669h2.667v8h-2.667v-8zM16.002 2.669c-7.36 0-13.333 5.973-13.333 13.333s5.973 13.333 13.333 13.333c7.36 0 13.333-5.973 13.333-13.333s-5.973-13.333-13.333-13.333zM16.002 26.669c-5.88 0-10.667-4.787-10.667-10.667s4.787-10.667 10.667-10.667c5.88 0 10.667 4.787 10.667 10.667s-4.787 10.667-10.667 10.667z"
  })), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-navigate_next",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.36 8l-1.88 1.88 6.107 6.12-6.107 6.12 1.88 1.88 8-8-8-8z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-place",
    viewBox: "0 0 26 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#7e7e7e",
    style: {
      stroke: "var(--color1, #7e7e7e)"
    },
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 2.8235,
    d: "M13.177 28.613c0 0 10.607-9.428 10.607-16.499 0-5.858-4.749-10.607-10.607-10.607s-10.607 4.749-10.607 10.607c0 7.071 10.607 16.499 10.607 16.499z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#7e7e7e",
    style: {
      stroke: "var(--color1, #7e7e7e)"
    },
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 2.8235,
    d: "M16.565 11.672c0 1.871-1.517 3.388-3.388 3.388s-3.388-1.517-3.388-3.388c0-1.871 1.517-3.388 3.388-3.388s3.388 1.517 3.388 3.388z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-calendar",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#7e7e7e",
    style: {
      stroke: "var(--color1, #7e7e7e)"
    },
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 3,
    d: "M8.714 9.853h14.458M7.728 1.656v2.459M23.969 1.656v2.459M28.75 8.615v17.229c0 2.485-2.015 4.5-4.5 4.5h-16.5c-2.485 0-4.5-2.015-4.5-4.5v-17.229c0-2.485 2.015-4.5 4.5-4.5h16.5c2.485 0 4.5 2.015 4.5 4.5z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-ticket",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#7e7e7e",
    style: {
      stroke: "var(--color1, #7e7e7e)"
    },
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M19.2 20.187v-0.259M19.199 16.183v-0.258M19.199 12.196v-0.258M6.682 4.613h9.319c0.053 1.887 1.599 3.4 3.499 3.4s3.446-1.513 3.498-3.4h2.319c2.807 0 5.082 2.275 5.082 5.082v12.609c0 2.807-2.275 5.082-5.082 5.082h-2.319c-0.053-1.887-1.599-3.4-3.498-3.4s-3.446 1.513-3.499 3.4h-9.319c-2.807 0-5.082-2.276-5.082-5.082l-0-12.609c0-2.807 2.275-5.082 5.082-5.082z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-check",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#007aff",
    style: {
      fill: "var(--color2, #007aff)"
    },
    d: "M28 16c0 6.627-5.373 12-12 12s-12-5.373-12-12c0-6.627 5.373-12 12-12s12 5.373 12 12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    style: {
      stroke: "var(--color3, #fff)"
    },
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 1.3333,
    d: "M12 16.667l3.333 2.667 6-6.667"
  })), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-logo",
    viewBox: "0 0 82 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.042 0.022c-0.021 0.021-0.042 2.671-0.042 5.897v5.855h0.155c0.408 0 1.343 0.253 1.877 0.513 1.054 0.506 1.828 1.35 2.235 2.439 0.232 0.612 0.246 1.694 0.028 2.39-0.274 0.886-1.033 1.806-1.891 2.313-0.59 0.351-1.448 0.64-1.891 0.64-0.183 0-0.38 0.028-0.422 0.056-0.070 0.042-0.091 1.335-0.091 5.911 0 3.226 0.007 5.869 0.014 5.876 0.014 0.007 18.416 0.028 40.895 0.042l40.874 0.028 0.021-5.876 0.014-5.883-0.471-0.049c-0.605-0.063-1.659-0.436-2.102-0.745-0.309-0.211-1.005-0.872-1.188-1.125-0.162-0.225-0.366-0.619-0.527-1.012-0.155-0.366-0.176-0.534-0.176-1.23 0-0.71 0.028-0.865 0.197-1.307 0.633-1.631 2.010-2.643 3.915-2.882 0.176-0.021 0.324-0.049 0.331-0.056 0.049-0.049 0.021-11.668-0.028-11.71-0.063-0.063-81.671-0.148-81.728-0.084zM41.739 0.767c21.544 0.021 39.201 0.056 39.243 0.077 0.035 0.028 0.063 2.024 0.063 5.124 0 4.281-0.014 5.096-0.098 5.166-0.056 0.049-0.303 0.134-0.548 0.197-2.116 0.527-3.726 2.334-3.873 4.344-0.105 1.35 0.344 2.566 1.322 3.585 0.752 0.78 1.539 1.202 3.043 1.624 0.063 0.014 0.084 0.281 0.084 0.991 0.007 6.15-0.014 9.271-0.056 9.314-0.098 0.098-79.759 0.049-80.061-0.049-0.127-0.042-0.119-10.185 0.007-10.284 0.049-0.042 0.288-0.127 0.541-0.197 1.919-0.52 3.374-1.954 3.761-3.704 0.358-1.624-0.169-3.255-1.441-4.428-0.64-0.598-1.223-0.928-2.038-1.188-0.365-0.119-0.71-0.232-0.766-0.26-0.091-0.042-0.098-0.787-0.084-5.145 0.007-2.798 0.035-5.11 0.063-5.138 0.042-0.042 1.406-0.112 1.596-0.077 0.042 0.007 17.699 0.028 39.243 0.049z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.711 1.372c-0.098 0.077-0.218 0.253-0.26 0.387-0.105 0.309 0.056 0.64 0.38 0.773 0.281 0.119 0.513 0.070 0.766-0.162 0.583-0.548-0.253-1.49-0.886-0.998z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.802 4.099c-0.471 0.232-0.527 0.766-0.12 1.111 0.506 0.429 1.279-0.112 1.061-0.731-0.134-0.373-0.59-0.562-0.942-0.38z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.602 5.175c-0.928 0.134-1.905 0.661-2.411 1.286-0.562 0.71-0.822 1.589-0.822 2.769 0.007 2.158 1.005 3.522 2.924 4 0.703 0.169 2.214 0.169 2.91-0.007 1.497-0.38 2.404-1.244 2.791-2.657 0.155-0.555 0.169-2.024 0.028-2.587-0.358-1.462-1.427-2.46-2.973-2.769-0.576-0.12-1.778-0.134-2.446-0.035zM26.31 7.094c0.464 0.141 0.731 0.358 0.949 0.766 0.176 0.344 0.19 0.422 0.19 1.314 0 1.082-0.070 1.357-0.436 1.764-0.64 0.71-2.137 0.626-2.65-0.148-0.281-0.429-0.337-0.738-0.309-1.729 0.021-0.879 0.028-0.935 0.232-1.258 0.26-0.415 0.485-0.59 0.928-0.71s0.703-0.119 1.097 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.301 6.187v1.019l1.357 0.014 1.35 0.021 0.021 3.037 0.014 3.044h2.601v-6.115h2.671v-2.038h-8.013v1.019z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.123 9.245v4.077h2.601l0.014-1.286 0.021-1.279 1.3-0.035c1.237-0.035 1.322-0.049 1.729-0.232 0.541-0.253 1.019-0.731 1.272-1.279 0.155-0.344 0.197-0.548 0.218-1.097 0.056-1.392-0.471-2.32-1.589-2.776-0.394-0.162-0.443-0.169-2.98-0.169h-2.587v4.077zM36.235 7.164c0.302 0.127 0.408 0.33 0.408 0.808 0 0.344-0.028 0.408-0.225 0.583-0.218 0.197-0.239 0.204-0.942 0.183l-0.717-0.021-0.021-0.731c-0.007-0.408 0-0.78 0.014-0.829 0.049-0.127 1.167-0.127 1.483 0.007z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.655 6.981c-0.162 0.148-0.218 0.26-0.225 0.45-0.021 0.682 0.745 0.984 1.181 0.464 0.253-0.295 0.232-0.576-0.063-0.872-0.302-0.302-0.583-0.316-0.893-0.042z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.683 9.701c-0.183 0.127-0.33 0.541-0.267 0.738 0.162 0.506 0.766 0.654 1.16 0.281 0.204-0.197 0.225-0.246 0.19-0.513-0.049-0.38-0.302-0.612-0.668-0.612-0.148 0-0.33 0.049-0.415 0.105z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.837 12.401c-0.633 0.274-0.527 1.181 0.155 1.307 0.619 0.113 1.026-0.71 0.562-1.153-0.183-0.169-0.513-0.239-0.717-0.155z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.641 15.318c-0.232 0.218-0.302 0.478-0.19 0.752 0.119 0.274 0.323 0.415 0.633 0.415s0.513-0.141 0.633-0.415c0.267-0.654-0.562-1.23-1.075-0.752z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.908 17.94c-0.373 0.091-0.612 0.562-0.464 0.928 0.267 0.633 1.209 0.485 1.314-0.211 0.063-0.422-0.415-0.829-0.851-0.717z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.26 18.495c-0.077 0.014-0.316 0.063-0.527 0.105-0.668 0.134-1.343 0.499-1.785 0.984-0.471 0.506-0.619 0.78-0.829 1.518-0.225 0.794-0.225 2.207 0.007 3.030 0.457 1.631 1.659 2.467 3.711 2.594 1.771 0.098 3.226-0.527 3.845-1.666 0.19-0.344 0.387-1.118 0.394-1.497v-0.19h-2.376l-0.070 0.316c-0.162 0.766-0.71 1.132-1.61 1.075-0.647-0.042-0.935-0.225-1.195-0.752-0.162-0.33-0.19-0.492-0.218-1.188-0.070-1.722 0.38-2.425 1.532-2.425 0.534 0 0.794 0.112 1.111 0.471 0.19 0.218 0.253 0.394 0.316 0.886 0.014 0.091 0.218 0.105 1.265 0.127l1.244 0.014v-0.197c0-0.408-0.162-1.047-0.365-1.476-0.415-0.836-1.258-1.427-2.397-1.659-0.485-0.098-1.687-0.141-2.052-0.070z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.182 18.53c-1.089 0.176-1.933 0.682-2.284 1.364-0.267 0.52-0.331 1.3-0.141 1.856 0.316 0.949 1.125 1.399 3.473 1.912 0.858 0.19 1.16 0.358 1.188 0.675 0.028 0.309-0.204 0.45-0.822 0.499-0.998 0.070-1.511-0.155-1.595-0.696l-0.050-0.274h-2.46l0.049 0.471c0.169 1.638 1.42 2.383 3.979 2.369 0.984-0.007 1.146-0.021 1.666-0.19 0.836-0.281 1.35-0.682 1.652-1.293 0.218-0.443 0.232-0.52 0.232-1.188 0-0.661-0.014-0.724-0.211-1.054-0.443-0.703-1.097-1.026-2.959-1.434-1.336-0.288-1.652-0.464-1.554-0.858 0.078-0.288 0.457-0.429 1.103-0.394 0.471 0.021 0.577 0.049 0.731 0.19 0.105 0.098 0.211 0.274 0.239 0.387l0.056 0.218 1.223 0.021 1.216 0.014-0.050-0.394c-0.133-1.146-0.963-1.898-2.39-2.172-0.59-0.112-1.673-0.127-2.292-0.028z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.301 19.542v1.019l1.357 0.014 1.35 0.021 0.021 3.037 0.014 3.044h2.601v-6.115h2.671v-2.038h-8.013v1.019z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.212 22.6v4.077h2.601v-8.154h-2.601v4.077z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.114 22.6v4.077h2.65l-0.021-0.766c-0.007-0.415 0-0.836 0.021-0.928 0.021-0.112 0.267-0.351 0.689-0.682 0.358-0.274 0.682-0.506 0.71-0.506 0.035 0.007 0.429 0.647 0.879 1.427l0.808 1.42 1.525 0.021c0.836 0.007 1.525-0.007 1.525-0.042 0-0.028-0.12-0.246-0.274-0.478-0.724-1.111-2.488-3.943-2.559-4.084-0.056-0.134-0.042-0.19 0.070-0.323 0.337-0.38 2.601-3.044 2.65-3.128 0.042-0.063-0.288-0.084-1.553-0.084h-1.603l-1.399 1.722c-0.766 0.949-1.413 1.708-1.434 1.687s-0.049-0.787-0.056-1.708l-0.021-1.666-1.3-0.021-1.307-0.014v4.077z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.587 22.6v4.077h7.099v-1.968h-4.498v-1.195h3.796v-1.898h-3.803l0.021-0.583 0.021-0.576 2.2-0.021 2.193-0.014v-1.898h-7.029v4.077z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.092 19.542v1.019h2.671v2.945c0 1.624 0.021 2.994 0.042 3.058 0.035 0.098 0.225 0.112 1.335 0.112h1.293v-6.115h2.671v-2.038h-8.013v1.019z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.753 20.772c-0.183 0.077-0.373 0.415-0.373 0.668 0 0.112 0.084 0.267 0.204 0.394 0.52 0.52 1.364 0.021 1.132-0.675-0.127-0.38-0.555-0.548-0.963-0.387z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.76 23.577c-0.422 0.26-0.478 0.773-0.12 1.104 0.246 0.225 0.576 0.225 0.851-0.007 0.267-0.218 0.323-0.457 0.197-0.766-0.162-0.387-0.583-0.541-0.928-0.33z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.697 26.396c-0.365 0.239-0.415 0.64-0.134 0.977 0.148 0.183 0.232 0.218 0.478 0.218 0.358 0 0.569-0.141 0.675-0.45 0.091-0.288 0.014-0.527-0.253-0.738-0.232-0.183-0.492-0.19-0.766-0.007z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.584 29.27c-0.576 0.576 0.239 1.483 0.879 0.984 0.267-0.211 0.344-0.45 0.253-0.738-0.162-0.478-0.766-0.612-1.132-0.246z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprite);
export default __webpack_public_path__ + "static/media/sprite.fbb1e986f873f32f7e5f06afeb3a36b7.svg";
export { ForwardRef as ReactComponent };